export const ADD_TICKET = 'ADD_TICKET';
export const ADD_TICKETS_COUNT = 'ADD_TICKETS_COUNT';
export const APPEND_TICKET = 'APPEND_TICKET';
export const REMOVE_TICKET = 'REMOVE_TICKET';
export const APPEND_TICKETS_COUNT = 'APPEND_TICKETS_COUNT';
export const REDUCE_TICKETS_COUNT = 'REDUCE_TICKETS_COUNT';

export function addTicket(info) {
    return { type: ADD_TICKET, info };
}
export function appendTicket(info) {
    return { type: APPEND_TICKET, info };
}
export function removeTicket(info) {
    return { type: REMOVE_TICKET, info };
}
export function addTicketsCount(info) {
    return { type: ADD_TICKETS_COUNT, info };
}
export function appendTicketsCount(info) {
    return { type: APPEND_TICKETS_COUNT, info };
}
export function reduceTicketsCount(info) {
    return { type: REDUCE_TICKETS_COUNT, info };
}

